import { render, staticRenderFns } from "./TextNote.vue?vue&type=template&id=bd6c9d20&"
import script from "./TextNote.vue?vue&type=script&lang=js&"
export * from "./TextNote.vue?vue&type=script&lang=js&"
import style0 from "./TextNote.vue?vue&type=style&index=0&id=bd6c9d20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports